export default {
  slogan: '<0>INVESTED IN YOU.</0>',
};
